export enum RoleEnum {
  //never change order
  POOL,
  DISPO,
  REQUESTER,
}
